import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import { FaCheck, FaLock } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import Header from '@components/Header/Header';
import SideBar from '@components/SideBar/SideBar';
import { ListPages } from '@enums/enums';
import { useDisbursement } from '../../contexts/DisbursementContext';
import styles from '../DashboardReports/DashboardReports.module.scss';
import style from '../Disbursement/Disbursement.module.scss';
import styleNew from './NewDisbursementSingle.module.scss';

import '@styles/main.scss';

const NewDisbursementSingle = (props: any) => {
  const scope = process.env['REACT_APP_MSAL_SCOPE'] || 'tu_scope_default';
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { email, amount } = useDisbursement();

  const handleGoBack = () => {
    navigate(ListPages.Disbursement, { replace: true });
  };

  const handleConfirmDisbursement = async () => {
    const activeAccount = instance.getActiveAccount() || accounts[0];
    if (!activeAccount) {
      console.error('No active account available');
      return;
    }

    const request = {
      scopes: [scope],
      account: activeAccount,
      prompt: 'select_account',
      claimsRequest: '{"id_token":{"acr":{"values":["mfa"]}}}',
    };

    try {
      const response = await instance.acquireTokenPopup(request);
      console.log(
        'Token acquired interactively with TFA',
        response.accessToken
      );

      navigate(ListPages.DisbursementProcessed);
    } catch (error) {
      console.error('Error getting token interactively with TFA', error);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <Header />

      <div className={styles.mainSection}>
        <SideBar />
        <div className={styles.mainSectionWorkArea}>
          <div>
            <div className="disbursement-layout">
              <div className={styles.tableHeader}>
                <h1 className={styles.headerText}>
                  {t('newDisbursement.title')}
                </h1>
              </div>

              <div className={styleNew.newDisbursementWorkingArea}>
                <div className={styleNew.containerData}>
                  <h3 className={styleNew.subTitle}>
                    {t('newDisbursement.subTitle')}
                  </h3>
                </div>
                <div className={styleNew.containerData}>
                  <div className={styleNew.containerEmail}>
                    <label htmlFor="email" className={styleNew.labelContainer}>
                      {t('disbursement.email')}:
                    </label>
                    <InputText
                      className={styleNew.inputDescription}
                      id="email"
                      value={email}
                      readOnly
                    />
                  </div>
                  <div className={styleNew.containerEmail}>
                    <label
                      className={styleNew.labelContainerAmount}
                      htmlFor="totalAmount"
                    >
                      {t('newDisbursement.totalAmount')}
                    </label>
                    <InputText
                      className={styleNew.inputDescription}
                      id="totalAmount"
                      value={`$${amount}`}
                      readOnly
                    />
                  </div>
                </div>
                <div className={styleNew.divider} />
                <div className={style.containerDisclaimer}>
                  <div className={style.disclaimer}>
                    {t('newDisbursement.disclaimer')}
                  </div>
                  <div className={styleNew.containerDescription}>
                    <FaLock size={40} />
                    <h3 className={styleNew.description}>
                      {t('newDisbursement.description')}
                    </h3>
                  </div>
                </div>

                <div className={style.containerButtonsDis}>
                  <Button className={style.buttonCancel} onClick={handleGoBack}>
                    {t('disbursement.buttonCancel')}
                  </Button>
                  {/* <Link to={ListPages.DisbursementProcessed}> */}
                  <Button
                    className={style.buttonContinue}
                    icon={<FaCheck size={16} />}
                    onClick={handleConfirmDisbursement}
                  >
                    {t('newDisbursement.buttonConfirm')}
                  </Button>
                  {/* </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewDisbursementSingle;
